import { render, staticRenderFns } from "./CFDI.vue?vue&type=template&id=eb714724"
import script from "./CFDI.vue?vue&type=script&lang=js"
export * from "./CFDI.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports